export default __webpack_public_path__ + "static/media/seattle.67483c28.png";